// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__K8OkI","mainContent":"styles_mainContent__CD8RL","loadImage":"styles_loadImage__PXeeu"};